import { useQuery } from "@tanstack/react-query";
import {
  producaoService,
  ProducaoResumoFilters,
} from "../services/producaoService";

export const useProducaoResumo = (filters: ProducaoResumoFilters) => {
  return useQuery({
    queryKey: ["producao-resumo", filters],
    queryFn: () => producaoService.getResumo(filters),
  });
};

export const useProducaoUsuarios = (filters: ProducaoResumoFilters) => {
  return useQuery({
    queryKey: ["producao-usuarios", filters],
    queryFn: () => producaoService.getUsuarios(filters),
  });
};

export const useMontagemUsuarios = (filters: ProducaoResumoFilters) => {
  return useQuery({
    queryKey: ["montagem-usuarios", filters],
    queryFn: () => producaoService.getUsuariosMontagem(filters),
  });
};

export const useDashboardOrigemPizzas = (filters: ProducaoResumoFilters) => {
  return useQuery({
    queryKey: ["dashboard-origem-pizzas", filters],
    queryFn: () => producaoService.getDashboardOrigemPizzas(filters),
  });
};
